import {localizePath, t, useSiteLanguage} from "../../i18n";
import restaurantInfo from "../../data/restaurant.json";
import {Link} from "react-router";

const Footer = () => {
    useSiteLanguage();
    return (
        <footer
            className="site-footer">

            <p className="footer-credit">© 2026 {restaurantInfo.name}</p>

            <div className="footer-links">
                <Link to={localizePath("/mentions-legales")} className="mx-2 cursor-pointer ">{t("legal.title")}</Link>
                <Link to={localizePath("/politique-confidentialite")}
                   className="mx-2 cursor-pointer">{t("privacy.title")}</Link>
            </div>

        </footer>
    );
};

export default Footer;